import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface ProduceErrorModalProps {
  visible: boolean;
  isContentModeration?: boolean;
  moderationReason?: string;
  onClose: () => void;
  onGoHome: () => void;
}

export const ProduceErrorModal: React.FC<ProduceErrorModalProps> = memo(
  ({ visible, isContentModeration = false, moderationReason, onGoHome }) => {
    const { t } = useTranslation();
    if (!visible) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999999]">
        <div className="tc-mv-blur rounded-regular p-6 max-w-lg w-full mx-4">
          <div className="flex flex-col justify-center items-center mb-4 text-center">
            <img
              alt="napster-logo"
              src="/assets/images/logo_napster_white.svg"
              className="h-[42px]"
            />
            <h2 className="text-white text-xl mt-4">
              {isContentModeration
                ? t('generation.contentModeration')
                : t('generation.somethingWentWrong')}
            </h2>
          </div>
          <p className="text-white mt-4 text-center">
            {isContentModeration
              ? moderationReason || t('generation.moderationDefault')
              : t('generation.couldntGenerate')}
          </p>
          <div className="flex justify-center mt-6">
            <button
              className="bg-white text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              onClick={onGoHome}>
              {t('generation.returnToHome')}
            </button>
          </div>
        </div>
      </div>
    );
  },
);

ProduceErrorModal.displayName = 'ProduceErrorModal';
